import SEO from '@/components/shared/SEO'
import KeyInformation from '@/components/KeyInformation'
import FAQ from '@/components/FAQ'
import { faqsData } from '@/components/FAQsPage'
import USPBanner from '@/components/USPBanner'
import TrustpilotBadge from '@/components/TrustpilotBadge'

const ContactPage = () => {
  return (
    <div className="flex-1">
      <SEO
        title="Contact Claims1 - Car Finance Claims Specialists | Get Help Today"
        description="Contact Claims1 for expert help with your car finance claim. Call 0330 828 0420 or email info@claims1.co.uk. Professional claims management services."
        keywords="contact Claims1, car finance claims help, claims management contact, car finance specialists contact"
        url="/contact"
        image="/Image/Contact-us-claims1.webp"
        imageAlt="Contact Claims1 car finance claims specialists"
        schemaType="ContactPage"
        schemaData={{
          mainEntity: {
            '@type': 'Organization',
            name: 'Claims1',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '+44-330-828-0420',
              contactType: 'customer service',
              email: 'info@claims1.co.uk',
              availableLanguage: 'English',
              hoursAvailable: {
                '@type': 'OpeningHoursSpecification',
                dayOfWeek: [
                  'Monday',
                  'Tuesday',
                  'Wednesday',
                  'Thursday',
                  'Friday',
                ],
                opens: '09:00',
                closes: '17:30',
              },
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: '84 Salop Street',
              addressLocality: 'Wolverhampton',
              postalCode: 'WV3 0SR',
              addressCountry: 'GB',
            },
          },
        }}
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Contact', url: '/contact' },
        ]}
      />

      <USPBanner />

      {/* Hero Section */}
      <div
        className="relative flex min-h-[70vh] items-center md:min-h-[91vh]"
        style={{
          backgroundImage: 'url("/Image/Contact-us-claims1.webp")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div className="absolute inset-0 bg-black/53"></div>
        <div className="relative z-10 container mx-auto px-4 py-8">
          <div className="px-4 text-center lg:px-20">
            <h1 className="mb-4 text-center text-4xl font-black tracking-tight text-white uppercase sm:mb-6 sm:text-6xl">
              Contact Us
            </h1>
            <p className="font-raleway-numbers mx-auto mb-4 max-w-xl text-lg leading-relaxed font-bold text-white/90 sm:text-xl md:mb-6 md:max-w-3xl lg:text-2xl">
              We&apos;re here to help with your vehicle finance claim questions.
              If you have any enquiries, please don&apos;t hesitate to reach out
              to us.
            </p>
            <div className="mt-6 flex justify-center md:mt-12">
              <TrustpilotBadge rating="4star" />
            </div>
          </div>
        </div>
      </div>

      {/* FAQ Section */}
      <FAQ
        faqs={faqsData.slice(0, 5)}
        includeStructuredData={false}
        className="py-3"
      />

      {/* Contact Information Section */}
      <div className="bg-white py-4 pb-8 lg:py-5 lg:pb-10">
        <div className="container mx-auto max-w-6xl px-4 sm:px-6">
          {/* Header and Subheader */}
          <div className="mb-8 text-center lg:mb-12">
            <h2 className="text-foreground mb-4 text-center text-4xl font-black sm:mb-6 sm:text-5xl">
              WE&apos;RE HERE TO HELP!
            </h2>
            <p className="text-foreground mb-8 text-center text-lg sm:mb-12">
              Need more support? Our friendly team is here to help with any
              questions you might have.
            </p>
          </div>
          <div className="grid grid-cols-1 gap-6 text-center sm:grid-cols-2 sm:gap-8 lg:grid-cols-3 lg:gap-0">
            <div className="flex flex-col items-center py-4 lg:relative lg:px-6">
              <div className="bg-opacity-50 absolute top-1/4 right-0 bottom-1/4 hidden w-px bg-gray-200 lg:block"></div>
              <div
                className="mb-4 flex h-20 w-20 items-center justify-center rounded-full border-2"
                style={{ borderColor: 'oklch(75% 0.183 55.934)' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10"
                  style={{ color: 'oklch(75% 0.183 55.934)' }}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  ></path>
                </svg>
              </div>
              <h3
                className="mb-2 text-lg font-bold sm:text-xl"
                style={{ color: '#002020' }}
              >
                Email At
              </h3>
              <div
                className="sm:text-l text-center text-base"
                style={{ color: '#002020' }}
              >
                info@claims1.co.uk
              </div>
            </div>
            <div className="flex flex-col items-center py-4 lg:relative lg:px-6">
              <div className="bg-opacity-50 absolute top-1/4 right-0 bottom-1/4 hidden w-px bg-gray-200 lg:block"></div>
              <div
                className="mb-4 flex h-20 w-20 items-center justify-center rounded-full border-2"
                style={{ borderColor: 'oklch(75% 0.183 55.934)' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10"
                  style={{ color: 'oklch(75% 0.183 55.934)' }}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  ></path>
                </svg>
              </div>
              <h3
                className="mb-2 text-lg font-bold sm:text-xl"
                style={{ color: '#002020' }}
              >
                Address
              </h3>
              <div
                className="font-raleway-numbers sm:text-l text-center text-base"
                style={{ color: '#002020' }}
              >
                84 Salop Street, Wolverhampton, WV3 0SR, United Kingdom
              </div>
            </div>
            <div className="flex flex-col items-center py-4 lg:relative lg:px-6">
              <div
                className="mb-4 flex h-20 w-20 items-center justify-center rounded-full border-2"
                style={{ borderColor: 'oklch(75% 0.183 55.934)' }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-10 w-10"
                  style={{ color: 'oklch(75% 0.183 55.934)' }}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
              </div>
              <h3
                className="mb-2 text-lg font-bold sm:text-xl"
                style={{ color: '#002020' }}
              >
                Office Hours
              </h3>
              <div
                className="font-raleway-numbers sm:text-l text-center text-base"
                style={{ color: '#002020' }}
              >
                Monday-Friday: 9am to 5.30pm, Weekends: Closed
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Key Facts Section */}
      <KeyInformation />
    </div>
  )
}

export default ContactPage
